/* global csrfToken */
import React from 'react';
import ReactDOM from 'react-dom';
import {IndexRoute, Router, Route, browserHistory} from 'react-router';
import App from './views/App.js';
import {Home, Team, TermsOfUse, PrivacyPolicy, Copyright, PurchaseTerms, About} from './views/Home';
import Retailer from './views/Retailer';
import Brand from './views/Brand';
import Collection from './views/collection';
import Apply from './views/Apply';
import NotFound from './views/NotFound.js';
import User, {
  UserSignin,
  UserSignout,
  UserCode,
  UserAccount,
  UserAccountOrderStatus,
  UserAccountStatus,
  UserPayments
} from "./views/user";
import Checkout, {
  CheckoutCreateAccount,
  CheckoutSuccess,
  CheckoutPaymentInformation,
  CheckoutAddAddress,
  CheckoutDeliveryDetails
} from "./views/checkout";
import Admin, {
  AdminBrand,
  AdminBrandEdit,
  AdminBrandCreate,
  AdminCollections,
  AdminCollectionEdit,
  AdminEmails,
  AdminProduct,
  AdminProductOptionEdit,
  AdminRecommendations,
  AdminRetailer,
  AdminRetailerView,
  AdminOrders,
  AdminQueue,
  AdminSingleOrder,
  AdminTools
} from "./views/admin/Admin.js";
import Api, {Utils} from "./Api";
import "./fonts/fonts.css";
import "./fontawesome/css/font-awesome.min.css";

Utils.setCSRF(csrfToken);

function errorCallback(msg, url, lineNo, columnNo, error) {
  if (!error) return;

  let user = Api.cache.getUser() || {};
  let retailer = Api.cache.getRetailer() || {};

  let errorObject = {
    pathname: window.location.pathname,
    userToken: user.token,
    retailerToken: retailer.token,
    msg: msg,
    url: url,
    lineNo: lineNo,
    columnNo: columnNo,
    message: error.message,
    stack: error.stack,
    user: user,
    retailer: retailer
  };

  Api.error(JSON.stringify(errorObject));
}

window.onerror = errorCallback;

ReactDOM.render(
  <Router history={browserHistory}>
    <Route path="/" component={App}>
      <IndexRoute component={Home}/>
      <Route path="about" component={About}/>
      <Route path="team" component={Team}/>
      <Route path="login" component={UserSignin}/>
      <Route path="logout" component={UserSignout}/>
      <Route path="retailer/:retailerToken" component={Retailer}/>
      <Route path="retailer/:retailerToken/product/:productId" component={Retailer}/>
      <Route path="retailer/:retailerToken/category/:categoryName" component={Retailer}/>
      <Route path="retailer/:retailerId/brand/:brandToken" component={Brand}/>
      <Route path="retailer/:retailerId/brand/:brandToken/product/:productId" component={Brand}/>
      <Route path="retailer/:retailerToken/collection/:collectionToken" component={Collection} />
      <Route path="apply" component={Apply}/>
      <Route path="tos" component={TermsOfUse}/>
      <Route path="purchaseterms" component={PurchaseTerms}/>
      <Route path="copyright" component={Copyright}/>
      <Route path="privacy" component={PrivacyPolicy}/>

      <Route path="user" component={User}>
        <IndexRoute component={UserSignin}/>
        <Route path="code/:email" component={UserCode}/>
        <Route path="logout" component={UserSignout}/>
        <Route path="account" component={UserAccount}>
          <IndexRoute component={UserAccountOrderStatus}/>
          <Route path="orders" component={UserAccountOrderStatus}/>
          <Route path="payments" component={UserPayments}/>
          <Route path="status" component={UserAccountStatus}/>
        </Route>
      </Route>

      <Route path="checkout" component={Checkout}>
        <IndexRoute component={CheckoutCreateAccount}/>
        <Route path="payment" component={CheckoutPaymentInformation}/>
        <Route path="address" component={CheckoutAddAddress}/>
        <Route path="delivery" component={CheckoutDeliveryDetails}/>
        <Route path="success" component={CheckoutSuccess}/>
      </Route>

      <Route path="admin" component={Admin}>
        <IndexRoute component={AdminBrand}/>
        <Route path="create" component={AdminBrandCreate}/>
        <Route path="brand/:brandToken/edit" component={AdminBrandEdit}/>

        <Route path="brand/:brandId/product/:productId" component={AdminProduct}/>
        <Route path="brand/:brandId/product/:productId/option/new"
               component={AdminProductOptionEdit}/>
        <Route path="brand/:brandId/product/:productId/option/:optionId/edit"
               component={AdminProductOptionEdit}/>

        <Route path="retailers" component={AdminRetailer}/>
        <Route path="retailers/:retailerToken" component={AdminRetailerView}/>

        <Route path="queue" component={AdminQueue}/>
        <Route path="orders" component={AdminOrders}/>
        <Route path="orders/:orderToken" component={AdminSingleOrder}/>

        <Route path="emails" component={AdminEmails}/>

        <Route path="recommendations" component={AdminRecommendations}/>

        <Route path="collections" component={AdminCollections}/>
        <Route path="collections/:collectionToken" component={AdminCollectionEdit}/>

        <Route path="tools" component={AdminTools}/>
      </Route>
      <Route path="*" component={NotFound}/>
    </Route>
  </Router>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/